<block-ui>

  <app-subheader [SubheaderTitle]="SubheaderTitle"  [ShowbreadCrumb]="ShowbreadCrumb" [ShowToolbar]="ShowToolbar">
    <div class="subheadertoolbar">

      <button type="button" title="Add" class="btn btn-success btn-sm btn-icon mr-2" data-toggle="modal"
              data-target="#AddPermissionModal" (click)="showAddPermissionModal()">
        <i class="kt-nav__link-icon fa fa-plus"></i>
      </button>

    </div>
    <div class="filter-container " [ngStyle]="{'display': ShowPageContent==true?'block':'none'}"
         *ngIf="IsFilterLoaded">
      <form [formGroup]="PermissionsForm">
        <div class="container-fluidposition-relative">

          <div class=" row" id="filtersContainer" data-isloaded="true">

            <div class="col-md-6">
              <BBSF-TextBox [options]="searchTextBox" [group]="PermissionsForm"></BBSF-TextBox>
            </div>
            <div class="col-md-6 d-flex justify-content-end align-items-end">
              <a class="btn btn-danger btn-bold btn-sm pv-reset text-white mt-4" id="applyFiltersBtn"
                 (click)="resetFilters()">{{utilityService.getResourceValue("Reset")}}</a>
            </div>
          </div>
        
        </div>
      </form>
    </div>


  </app-subheader>
  <!-- Page Content -->
  <div [ngStyle]="{'display': ShowPageContent==true?'block':'none'}" class="container-fluid">

      <div class="table-responsive-x">
        <!--begin::Permission list-->
        <table class="table amsx-table-users">
          <thead>
            <tr>

              <th>{{utilityService.getResourceValue("Name")}}</th>
              <th *ngIf="!ProductionMode">{{utilityService.getResourceValue("SysName")}}</th>
              <th class="text-center">{{utilityService.getResourceValue("Action")}}</th>
            </tr>
          </thead>
          <tbody id="listingContainer">

            <tr *ngFor="let Permission of PermissionsPagingResult">

              <td class="align-middle">
                <div class="kt-user-card-v2">
                  <div class="kt-user-card-v2__details">
                    <a href="javascript:void(0)" *ngIf="language=='en'" class="kt-user-card-v2__name">{{Permission.name.english}}</a>
                    <a href="javascript:void(0)" *ngIf="language=='ar'" class="kt-user-card-v2__name">{{Permission.name.arabic}}</a>


                  </div>
                </div>
              </td>
              <td *ngIf="!ProductionMode" class="align-middle">{{Permission.sysName}}</td>

              <td class="text-center align-middle">
                <div class="dropdown dropdown-inline ams-dropdown">
                  <button type="button" class="btn btn-clean btn-icon btn-sm" data-toggle="dropdown"
                          aria-haspopup="true" aria-expanded="true">
                    <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                  </button>
                  <div class="dropdown-menu dropdown-menu-right p-0">

                    <ul class="kt-nav">
                      <li class="kt-nav__item">
                        <a class="kt-nav__link" data-toggle="modal" data-target="#EditPermissionModal"
                           (click)="showEditPermissionModal(Permission)">
                          <i class="kt-nav__link-icon fa fa-edit" aria-hidden="true"></i>
                          <span class="kt-nav__link-text">{{utilityService.getResourceValue("Edit")}}</span>
                        </a>
                      </li>

                      <li class="kt-nav__item">
                        <a h class="kt-nav__link" id="btnResetPass" data-toggle="modal"
                           data-target="#deletePermissionModal" (click)="showDeletePermissionModal(Permission)">
                          <i class="kt-nav__link-icon fa fa-cog"></i>
                          <span class="kt-nav__link-text">{{utilityService.getResourceValue("Delete")}}</span>
                        </a>
                      </li>


                    </ul>

                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="PermissionsPagingResult.length == 0">
              <td colspan="3">
                <lib-empty-data></lib-empty-data>
              </td>
            </tr>
          </tbody>
        </table>
        <BBSF-Paging (Items)="setPermissionsListResult($event)" *ngIf="IsFilterLoaded" [options]="PermissionsPaging"
                     [group]="PermissionsForm" #PermissionPagingViewElement>
        </BBSF-Paging>
        <!--end::Permission list-->
      </div>
   
  </div>
  <!-- Add Modal -->
  <div class="modal fade" id="AddPermissionModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <form [formGroup]="AddPermissionForm" *ngIf="IsAddPermissionFormLoaded" (ngSubmit)="addPermission()">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">  {{utilityService.getResourceValue("AddPermissions")}}</h5>
            <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-icon">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">

            
            <div class="row">
              <div class="col-md-12">
                <BBSF-MultiLingualTextBox [options]="MultiLingualName" [group]="AddPermissionForm"></BBSF-MultiLingualTextBox>
              </div>
            </div>
            <div class="row" *ngIf="!ProductionMode">
              <div class="col-md-12">
                <BBSF-TextBox [options]="SysName" [group]="AddPermissionForm">
                </BBSF-TextBox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <BBSF-DropdownList [options]="Organization" [group]="AddPermissionForm"></BBSF-DropdownList>
              </div>
            </div>


          </div>
          <div class="modal-footer">
            <button #ClosePermissionModal id="ClosePermissionModal" type="button" class="btn btn-secondary"
                    data-dismiss="modal">
              {{utilityService.getResourceValue("CancelLabel")}}
            </button>
            <button type="submit" class="btn btn-primary">{{utilityService.getResourceValue("SaveLabel")}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Edit Modal -->
  <div class="modal fade" id="EditPermissionModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <form [formGroup]="EditPermissionForm" *ngIf="IsEditPermissionModelLoaded" (ngSubmit)="editPermission()">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"> {{utilityService.getResourceValue("EditPermission")}} </h5>
            <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-icon">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">

            <div class="row">
              <div class="col-md-12">
                <BBSF-MultiLingualTextBox [options]="EditMultiLingualName" [group]="EditPermissionForm"></BBSF-MultiLingualTextBox>
              </div>
             
            </div>
            <div class="row">
              <div class="col-md-12" *ngIf="!ProductionMode">
                <BBSF-TextBox [options]="EditSysName" [group]="EditPermissionForm">
                </BBSF-TextBox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <BBSF-DropdownList [options]="EditOrganization" [group]="EditPermissionForm"></BBSF-DropdownList>
              </div>
            </div>


          </div>
          <div class="modal-footer">
            <button #CloseEditPermissionsModal id="CloseEditPermissionsModal" type="button" class="btn btn-secondary"
                    data-dismiss="modal">
              {{utilityService.getResourceValue("CancelLabel")}}
            </button>
            <button type="submit" class="btn btn-primary">{{utilityService.getResourceValue("SaveLabel")}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>


  <!-- Delete  Modal -->
  <div class="modal fade" id="deletePermissionModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <form *ngIf="IsOpenDeletePermissionsModal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"> {{utilityService.getResourceValue("DeletePermission")}}</h5>

            <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-icon">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="note note-warning text-center">
              <h3 *ngIf="language=='en'">
                Are you sure that you want to delete this Permission ?
              </h3>
              <h3 *ngIf="language=='ar'">
                هل أنت متأكد أنك تريد حذف هذا الإذن؟
              </h3>
            </div>

            <div id="" class="">
              <div class="table-responsive-x">

              </div>
            </div>


          </div>
          <div class="modal-footer">
            <button #CloseDeletePermissionsModal id="CloseDeletePermissionsModal" type="button" class="btn btn-secondary"
                    data-dismiss="modal">
              {{utilityService.getResourceValue("CancelLabel")}}
            </button>
            <button type="button" (click)="deletePermission()"
                    class="btn btn-danger">
              {{utilityService.getResourceValue("Delete")}}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
